import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpMethod } from './http-method';


@Injectable()
export class ResponseHandler {
    public handleSuccess<T>(response: T, httpMethod: HttpMethod): Observable<T> {
        return of(response);
    }
}
